import { render, staticRenderFns } from "./IpInfoPanel.vue?vue&type=template&id=33228462"
import script from "./IpInfoPanel.vue?vue&type=script&lang=ts"
export * from "./IpInfoPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports